<template>
  <div>
    <div class="over-lay" @click="closePopup"></div>
    <div class="popup">
      <div class="hdr">Find domain?</div>
      <div class="txt-desc" v-html="text"></div>
      <form
        v-on:submit.prevent="updateDomain"
        class="form-section"
        ref="formDomain"
      >
        <Input-With-Label
          v-if="showName"
          ref="firstName"
          :autocomplete="'off'"
          :type="'text'"
          :value="firstName"
          :required="'true'"
          :id="'firstName'"
          :placeholder="'First Name'"
        />
        <Input-With-Label
          v-if="showName"
          ref="lastName"
          :autocomplete="'off'"
          :type="'text'"
          :value="lastName"
          :required="'true'"
          :id="'lastName'"
          :placeholder="'Last Name'"
        />
        <Input-With-Label
          ref="domain"
          :autocomplete="'off'"
          :type="'text'"
          :value="domain"
          :required="'true'"
          :id="'domain'"
          :pattern="'(.+[.?].+)'"
          :title="'Please enter valid domain'"
          :placeholder="'Company Domain'"
        />
        <div class="btn-section d-flex">
          <!-- <button @click="closePopup">Cancel</button> -->
          <input :class="'btn-blue'" :value="'View Email'" :type="'submit'" />
          <V-Button
            :className="'cancelBtn'"
            :callback="closePopup"
            :text="'Cancel'"
            :type="'button'"
          ></V-Button>

          <!-- <button type="submit" class="btn-blue">Update</button> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// import homeIcon from './../assets/icons/svg/home.svg'
import button from './../components/Button'
import InputWithLabel from './../components/InputWithLabel'
export default {
  name: 'Add-Domain-Find-Email',
  props: ['text', 'data', 'showName'],
  data: function() {
    return {
      showPopup: false,
      domain: '',
      firstName: this.data.firstName,
      lastName: this.data.lastName
    }
  },
  components: {
    'V-Button': button,
    'Input-With-Label': InputWithLabel
  },
  methods: {
    closePopup() {
      this.$emit('clickedOutside', true)
    },
    updateDomain() {
      const dataMap = {
        domain: this.$refs.domain.$refs.input.value
      }

      if (this.showName) {
        dataMap.firstName = this.$refs.firstName.$refs.input.value
        dataMap.lastName = this.$refs.lastName.$refs.input.value
      }
      this.closePopup()
      this.$parent.$emit('newDomainSubmitted', dataMap, this.data.uniqueId)
    }
  },
  mounted: function() {
    if (this.showName) {
      this.$refs.firstName.$refs.input.focus()
    } else {
      this.$refs.domain.$refs.input.focus()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.over-lay {
  background: rgba(102, 112, 128, 0.2);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 90%;
  color: #787878;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 25px 16px;
  background: #ffffff;
  border: 1px solid rgba(102, 112, 128, 0.2);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  .hdr {
    font-size: 22px;
    text-align: center;
    font-weight: 500;
    display: none;
  }
  .txt-desc::v-deep {
    line-height: 1.46;
    font-size: 15px;
    margin-bottom: 10px;
    span {
      color: $primary-color;
    }
  }
  .form-section {
    width: 100%;
    gap: 15px;
    display: flex;
    flex-direction: column;
    .btn-section::v-deep {
      width: 100%;
      margin-top: 10px;
      overflow: hidden;
      gap: 10px;

      div {
        width: 50%;
      }

      input.btn-blue,
      .cancelBtn {
        font-family: 'Figtree-Regular';
        font-size: 14px;
        line-height: 20px;
        border-radius: 6px;
        padding: 7px;
        cursor: pointer;
      }
      input.btn-blue {
        width: 50%;
        border: 0;
        background-color: $primary-color;
        color: $white;
        &:hover {
          background-color: lighten($color: $primary-color, $amount: 5%);
        }
      }
      .cancelBtn {
        margin: 0;
        width: 100%;
        color: $grey-color;
        border: 1px solid rgba(102, 112, 128, 0.2);
        background: #fff;
        &:hover {
          background-color: lighten($color: $grey-color, $amount: 52%);
        }
      }
    }
  }
}
</style>
